<template>
  <el-dialog title="资质采购" :visible.sync="show" :before-close="close" center destroy-on-close>
    <table-list :loading="loading" :data="tableData" :page="page" :page-size="pageSize" :total="totalCount" :columnDefs="columnDefs" @pageChange="pageChange"></table-list>
  </el-dialog>
</template>
<script>
import TableList from '@/components/TableList.vue'
// import { ApprovalStatus } from '@/utils/constants'
import { compApplyAssetsPurchase } from '@/api/assets.js'
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalCount: 0,
      show: false,
      loading: false,
      tableData: [],
      columnDefs: [
        // { label: '申请单编号', prop: 'eventId' },
        { label: '资产编号', prop: 'assetsNo' },
        { label: '物品名称', prop: 'assetsName' },
        { label: '品牌', prop: 'brand' },
        {
          label: '采购类型',
          prop: 'purchaseType',
          formatter: (row) => {
            return row.purchaseType === 0 ? '已有资产' : '新资产'
          }
        },
        { label: '采购数量', prop: 'amount' },
        { label: '采购总价', prop: 'totalPrice' },
        { label: '申请人', prop: 'applyUser' },
        {
          label: '审核人',
          formatter: (row) => {
            return row.auditPerson || row.preAuditPerson
          }
        },
        // {
        //   label: '审核状态',
        //   formatter: (row) => {
        //     let status = ApprovalStatus.find((item) => item.value === row.status)
        //     return status?.label || ''
        //   }
        // },
        { label: '申请时间', prop: 'createTime' },
      ]
    }
  },
  components: {
    TableList
  },
  methods: {
    close() {
      this.show = false
    },
    async getFixedAssetsDetails(type, item, activeName) {
      this.type = type
      this.activeName = activeName
      this.id = item.id
      this.loading = true
      await compApplyAssetsPurchase('queryModel', { status: 1, assetsNo: item.assetsNo }).then((res) => {
        let result = res.result.records
        if (res.result.records.length === 0) {
          this.$message.warning('暂无采购记录！')
          return
        }
        this.tableData = result
        this.totalCount = res.result.total
        this.show = true
        this.loading = false
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  width: 80% !important;
}
</style>